module.exports = __webpack_public_path__ + "img/award-prize-03.ef69bd8b.png";